import { Component, Input } from '@angular/core';
import { StepService } from '../services/step.service';

@Component({
  selector: 'app-summary-step',
  templateUrl: './summary-step.component.html',
  styleUrls: ['./summary-step.component.scss'],
})
export class SummaryStepComponent {
  @Input() stepNumber: number;
  @Input() readOnly = false;

  constructor(private stepService: StepService) {}

  get translateString(): string {
    return this.stepService.stepName(this.stepNumber) + '.SUMMARYTITLE';
  }

  get stepDisplayNumber(): string {
    if (this.stepNumber >= 10) {
      return this.stepNumber.toString();
    }
    return '0' + this.stepNumber;
  }

  gotoStep() {
    this.stepService.moveToStep(this.stepNumber);
  }
}
